import axios from "../common"
import { iLoginData } from "../types"

export const ApiSignIn = async (loginData: iLoginData) => {
    console.log('[ApiSignIn] - ', loginData)
    return axios.post("/auth/login/", loginData, { withCredentials: true })
}
